import { Component, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { DoctorsListDialogComponent } from './components/doctors-list-dialog.component';
import { SharedService } from 'src/app/core/services/shared.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-doctor-list',
  templateUrl: 'doctor-list.component.html',
  styleUrls: ['doctor-list.component.scss']
})
export class DoctorListComponent implements OnInit {

  doctorList: Array<any> = [];

  constructor(
    public dialog: MatDialog,
    private location: Location,
    private sharedService: SharedService
  ) { }

  sidenavToggle = false;

  doctorsArray: Array<any> = [];
  doctorsList: Array<any> = [];
  dataSource = new MatTableDataSource<any>();
  resultsLength = 0;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  displayedColumns: string[] = ['doctorName', 'registeredNo', 'email', 'contactNo', 'speciality', 'education', 'visitDetails', 'actions'];

  doctorSearch: FormControl = new FormControl(null, Validators.required);

  ngOnInit(): void {
    this.getDoctors();
    let token = localStorage.getItem('sidenav');
    if(token === 'true') {
      this.toggleNav(token);
    }
  }

  lastRoute() {
    this.location.back();
  }

  toggleNav(value: any) {
    if (value === 'true') {
      this.sidenavToggle = true;
    } else if (value === 'false') {
      this.sidenavToggle = false;
    }
  }

  applyFilter(event: Event) {
    this.dataSource = new MatTableDataSource<any>(this.doctorsList);
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  getDoctors() {
    this.dataSource = new MatTableDataSource<any>();
    this.dataSource.paginator = null;
    this.doctorsArray = [];
    this.sharedService.getDoctors().subscribe(
      (res: any) => {
        if (res.body.doctorWithVisitingDetails) {
          var providerBranchProfile = res.body.providerBranchProfile?.id;
          for (let doctorEntry of res.body.doctorWithVisitingDetails) {
            var visitingDays = [];
            var visitingHours = [];
            let doctorType: any;
            if (doctorEntry.doctorProviderMapping?.length > 0) {
              for (let mappingEntry of doctorEntry.doctorProviderMapping) {
                visitingDays.push(mappingEntry.visitingDays);
                visitingHours.push(mappingEntry.visitingHours);
                doctorType = mappingEntry.doctorType;
              }

              let newDoctorObj = {
                doctorId: doctorEntry.doctorDetails.id,
                providerBranchProfileId: providerBranchProfile,
                doctorName: doctorEntry.doctorDetails.doctorName,
                registrationNumber: doctorEntry.doctorDetails.registrationNumber,
                email: doctorEntry.doctorDetails.emailId,
                contactNo: doctorEntry.doctorDetails.phoneNumber,
                highestEducation: doctorEntry.doctorDetails.education,
                speciality: doctorEntry.doctorDetails.speciality,
                doctorType: doctorType,
                visitingDays: visitingDays,
                visitingHours: visitingHours
              };
              this.doctorsArray.push(newDoctorObj);
            }
            //visitingDays = doctorMapping.visitingDays.split(',').map(item => item.trim());
            //visitingHours = doctorMapping.visitingHours.split(',').map(item => item.trim());
          }
        }
        this.doctorsList = this.doctorsArray;
        this.dataSource = new MatTableDataSource<any>(this.doctorsArray);
        this.resultsLength = this.doctorsArray.length;
        this.dataSource.paginator = this.paginator!;

      },
      (err: any) => {
        Swal.fire('', err.error.message ? err.error.message : err.message, 'error');
      }
    );
  }

  deleteDoctorEntry(id: any) {
    this.sharedService.deleteDoctor(id).subscribe(
      (res: any) => {
        this.getDoctors();
        Swal.fire('', 'Deleted Successfully', 'success');
      },
      (err: any) => {
        Swal.fire('', err.error.message ? err.error.message : err.message, 'error');
      }
    );
  }

  downloadReport(fileUrl: any) {
    /*this.tariffService.fetchDocument(this.httpUrlEncodingCodec.decodeValue(fileUrl)).subscribe(
      (res: any) => {
       if (res.body.docType === 'pdf') {
        const link = document.createElement('a');
        link.setAttribute('target', '_blank');
        link.setAttribute('href', `data:application/pdf;base64,${res.body.docBaseSF}`);
        link.setAttribute('download', res.body.docName);
        document.body.appendChild(link);
        link.click();
        link.remove();
      } else if (res.body.docType === 'xlsx') {
        const link = document.createElement('a');
        link.setAttribute('target', '_blank');
        link.setAttribute('href', `data:application/xlsx;base64,${res.body.docBaseSF}`);
        link.setAttribute('download', res.body.docName);
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
      },
      (err: any) => {
        Swal.fire('', err.error.message ? err.error.message : err.message, 'error');
      }
    );*/
  }


  openDialog() {
    const dialogRef = this.dialog.open(DoctorsListDialogComponent, { data: { mode: 'Add' } });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'success') {
        this.getDoctors();
      }
    });
  }
  openEditDialog(element: any) {
    const dialogRef = this.dialog.open(DoctorsListDialogComponent, { data: { editData: element, mode: 'Edit' } });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'success') {
        this.getDoctors();
      }
    });
  }
  openViewDialog(element: any) {
    const dialogRef = this.dialog.open(DoctorsListDialogComponent, { data: { editData: element, mode: 'View' } });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'success') {
        this.getDoctors();
      }
    });
  }
}